import { render, staticRenderFns } from "./lastPositionsItem.vue?vue&type=template&id=2191ec50&"
import script from "./lastPositionsItem.vue?vue&type=script&lang=js&"
export * from "./lastPositionsItem.vue?vue&type=script&lang=js&"
import style0 from "./lastPositionsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports